module.exports = __webpack_public_path__ + "media/twirl.8eb1617f.wav";